import React, { SyntheticEvent, useContext, useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { useDebounce } from 'react-use'
import toggleFavorite from 'shared/redux/favorites'
import UserContext from '../context/user'
// @ts-ignore
import css from './favorite.css'

type Props = {
    id: string | number
    url: string
    isFavorite: boolean
    className?: string
    showLabel?: boolean
    onClick?: Function
    scale?: number
    toggleFavorite: Function
}

const ANIMATION_TIME = 500
const Favorite = ({ id, url, showLabel = false, className, scale, isFavorite, toggleFavorite, onClick }: Props) => {
    const transform = `scale(${scale || 1})`
    const style = {
        WebkitTransform: transform,
        MozTransform: transform,
        Transform: transform,
    }

    const { user } = useContext(UserContext)
    const showAnimation = useRef(false)
    const [isActive, setIsActive] = useState(isFavorite)
    useEffect(() => {
        if (!showAnimation.current) {
            setIsActive(isFavorite)
        }
    }, [isFavorite])

    useDebounce(
        () => {
            if (showAnimation.current) {
                toggleFavorite({ id, url }, user)
                onClick?.({ id, url, is_favorite: isActive })
                // set this back to false after the debounce and the animation
                showAnimation.current = false
            }
        },
        ANIMATION_TIME,
        [isActive]
    )

    const doTheToggle = (e: SyntheticEvent<HTMLElement, Event>) => {
        e.preventDefault()
        e.stopPropagation()
        // flag this so we show the animation
        showAnimation.current = true
        setIsActive(!isActive)
    }

    return (
        <div className={className ? `${className} ${css.favorite}` : css.favorite} style={style} onClick={doTheToggle}>
            <div
                className={isActive ? css.favoriteIconActive : css.favoriteIcon}
                data-animated={showAnimation.current}
            />
            {showLabel && <span>Favorite</span>}
        </div>
    )
}

export default connect(undefined, { toggleFavorite })(Favorite)
